
import React from "react";
import "./AcademicEvents.css";
import eventImg1 from "../assets/activity/1.jpeg";
import eventImg2 from "../assets/activity/2.jpeg";
import eventImg3 from "../assets/activity/3.jpeg";

const results = [
  { name: "Rakshika Dubey", standard: "Class X", percentage: "97.4%" },
  { name: "Yadhnyavalkya Kude", standard: "Class X", percentage: "97.4%" },
  { name: "Debashreeta Dey", standard: "Class X", percentage: "97.2%" },
  { name: "Ishan Khapekar", standard: "Class X", percentage: "96.6%" },
  { name: " Vedant Khule", standard: "Class X", percentage: "94.8%" },
  { name: "Samriddhi Singh ", standard: "Class X", percentage: "94.4%" },
   { name: "Akshita Rawat ", standard: "Class X", percentage: "93.8%" },
  { name: "Darshil Khawase ", standard: "Class X", percentage: "93.6%" },
  { name: " Avni Sengar ", standard: "Class X", percentage: "93.4%" },
  { name: "Mohit Kumar ", standard: "Class X", percentage: "92.6%" }
];

const events = [
  {
    image: eventImg1,
    date: "27 Aug 2026",
    category: "Eco-Art",
    title: "Eco-Friendly Clay Ganesh Making Activity",
    description:
      "A beautiful blend of devotion, creativity and fun as students explored eco-friendly art.",
    highlight: "Std. I to X • 350+ Student Sculptors"
  },
  {
    image: eventImg2,
    date: "27 Aug 2026",
    category: "Leadership",
    title: "Investiture Ceremony – Bharat Scouts & Guides",
    description:
      "A proud day as students began their journey as members of the Scouts and Guides movement.",
    highlight: "Std. VI Troop • Formal Scarfing"
  },
  {
    image: eventImg3,
    date: "25 Aug 2026",
    category: "Career Mastery",
    title: "Exploring Careers Beyond the Classroom",
    description:
      "Students visited IIM Nagpur to explore career opportunities and gain academic insights.",
    highlight: "Std. XI & XII • Campus Immersion"
  }
];

const AcademicEvents = () => {
  return (
    <section className="academic-hub" id="calendarEventsSection">
      <div className="academic-container">

        <div className="academic-heading">

          <h2>Student <span>Achievements & Latest</span> Events</h2>

          <p>
            Celebrating academic excellence, student achievements,
            creativity and memorable moments of campus life.
          </p>
        </div>

        <div className="academic-main-grid">

          {/* LEFT: STUDENT RESULTS */}
          <div className="academic-planner-card results-main-card">

            <div className="academic-card-heading">
              <div className="academic-heading-icon">
                <i className="bi bi-trophy-fill"></i>
              </div>

              <div>
                <h3>Our Student Achievers</h3>
                <p>Celebrating academic excellence</p>
              </div>
            </div>



            <div className="results-heading-row">
              <h4>Outstanding Performers</h4>
              <span>Session 2025–26</span>
            </div>

            <div className="students-result-scroll">
              {results.map((student, index) => (
                <div className="student-result-card" key={index}>

                  <div className="student-result-photo">
                    <img
                      src={`/assets/images/student${index + 1}.jpg`}
                      alt={student.name}
                      onError={(e) => {
                        e.currentTarget.src =
                          `https://placehold.co/150x150/dce9ff/174c9c?text=Student+${index + 1}`;
                      }}
                    />
                  </div>

                  <div className="student-result-info">
                    <h4>{student.name}</h4>
                    <span>{student.standard}</span>
                  </div>

                  <div className="student-percentage">
                    <strong>{student.percentage}</strong>
                    <small>Grade A1</small>
                  </div>

                </div>
              ))}
            </div>

            <a
              href="/assets/pdf/student-results-2025-26.pdf"
              download
              className="academic-download-btn result-download-main"
            >
              <i className="bi bi-download"></i>
              Download Student Results
            </a>

            <div className="results-bottom-note">
              <i className="bi bi-stars"></i>
              Every achievement is a step towards a brighter future!
            </div>

          </div>

          {/* RIGHT: LATEST EVENTS - SINGLE SECTION */}
          <div className="academic-right-column">

            <div className="right-section-heading">
              <div>
                <h3>Our Latest Events</h3>
                <p>Celebrating learning, creativity & leadership</p>
              </div>

              <i className="bi bi-stars"></i>
            </div>

            <div className="events-scroll-area">

              {events.map((event, index) => (
                <div className="academic-event-card" key={index}>

                  <div className="academic-event-image">
                    <img
                      src={event.image}
                      alt={event.title}
                    />
                  </div>

                  <div className="academic-event-details">

                    <div className="academic-event-meta">
                      <span>
                        <i className="bi bi-calendar3"></i>
                        {event.date}
                      </span>

                      <label>{event.category}</label>
                    </div>

                    <h4>{event.title}</h4>

                    <p>{event.description}</p>

                    <span className="event-highlight">
                      <i className="bi bi-award-fill"></i>
                      {event.highlight}
                    </span>

                  </div>
                </div>
              ))}

            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default AcademicEvents;
